import Styles from './Section.module.scss';
import cx from 'classnames';

function Section({ children }) {
  return <section className={cx(Styles.Section, 'd-flex flex-column')}>{children}</section>;
}

export default Section;
